var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9593 3.918L9.58164 5.29581C9.02379 5.85373 8.11926 5.85379 7.56133 5.29593C7.00341 4.73807 7.00336 3.83354 7.56121 3.27561L8.93887 1.89781C11.4692 -0.632528 15.5717 -0.632585 18.1021 1.89776C20.6324 4.42807 20.6324 8.53051 18.1021 11.0609L16.7244 12.4387C16.1666 12.9966 15.2621 12.9966 14.7041 12.4388C14.1463 11.8809 14.1462 10.9764 14.7041 10.4185L16.0817 9.04067C17.4963 7.62611 17.4963 5.33261 16.0817 3.91806C14.6673 2.50353 12.3738 2.5035 10.9593 3.918ZM5.29566 7.56121C5.85357 8.11907 5.85363 9.0236 5.29577 9.58153L3.91811 10.9593C2.50356 12.3739 2.5035 14.6674 3.91806 16.082C5.3326 17.4964 7.62599 17.4964 9.04056 16.082L10.4182 14.7041C10.9761 14.1463 11.8806 14.1462 12.4385 14.7041C12.9964 15.262 12.9965 16.1664 12.4386 16.7244L11.061 18.1021C8.53063 20.6324 4.42808 20.6326 1.89776 18.1023C-0.632567 15.5719 -0.632585 11.4695 1.8977 8.93914L3.27534 7.56133C3.8332 7.00341 4.73773 7.00336 5.29566 7.56121ZM13.153 8.8673C13.7109 8.3094 13.7109 7.40488 13.153 6.84698C12.5951 6.2891 11.6906 6.2891 11.1327 6.84698L6.84699 11.1327C6.2891 11.6906 6.2891 12.5951 6.84699 13.153C7.40489 13.7109 8.3094 13.7109 8.8673 13.153L13.153 8.8673Z",
    fill: "#ABDEF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.36cafd19be9502dd1a6a62810eb3f0f0.svg";
export { ForwardRef as ReactComponent };